module.exports = __webpack_public_path__ + "img/exit.cdcbf0d7.svg";